import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { blogPosts } from './blogData';
import './BlogPost.css';
import { Helmet } from 'react-helmet';

function getCurrentDate() {
    const now = new Date();
    const day = String(now.getDate()).padStart(2, '0');
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const year = String(now.getFullYear()).slice(-2);
    return `${day}/${month}/${year}`;
}

const BlogPost = () => {
    const { id } = useParams();
    const post = blogPosts.find(post => post.id === parseInt(id));

    useEffect(() => {
        if (window.gtag) {
            window.gtag('event', 'blog_post_view', {
                event_category: 'Blog',
                event_label: post ? post.title : 'Unknown',
                value: post ? post.id : undefined
            });
        }
    }, [post]);

    if (!post) {
        return (
            <div className="blog-post-not-found">
                <h2>Post not found</h2>
                <Link to="/blog">Back to Blog</Link>
            </div>
        );
    }

    return (
        <>
            <Helmet>
                <title>{post.title} | LED Scroller Blog</title>
                <meta name="description" content={post.summary || post.title} />
                <meta property="og:title" content={post.title + ' | LED Scroller Blog'} />
                <meta property="og:description" content={post.summary || post.title} />
                <meta property="og:type" content="article" />
                <meta property="og:url" content={`https://ledscroller.com/blog/${post.id}`} />
                <meta property="og:image" content={post.detailImage} />
                <script type="application/ld+json">{`
                  {
                    "@context": "https://schema.org",
                    "@type": "BlogPosting",
                    "headline": "${post.title}",
                    "description": "${post.summary || post.title}",
                    "image": "${post.detailImage}",
                    "author": {
                      "@type": "Organization",
                      "name": "LED Scroller Team"
                    },
                    "publisher": {
                      "@type": "Organization",
                      "name": "LED Scroller",
                      "logo": {
                        "@type": "ImageObject",
                        "url": "https://ledscroller.com/logo192.png"
                      }
                    },
                    "datePublished": "${post.date}",
                    "mainEntityOfPage": {
                      "@type": "WebPage",
                      "@id": "https://ledscroller.com/blog/${post.id}"
                    }
                  }
                `}</script>
            </Helmet>
            <div className="blog-post">
                <div className="container">
                    <div className="blog-post-header">
                        <Link to="/blog" className="back-to-blog">
                            ← Back to Blog
                        </Link>
                        <h1 className="blog-post-title">{post.title}</h1>
                        <div className="blog-post-meta">
                            <span className="blog-post-date">{getCurrentDate()}</span>
                            <span className="blog-post-author">By {post.author}</span>
                            <span className="blog-post-category">{post.category}</span>
                        </div>
                    </div>

                    <div className="blog-post-image">
                        <img src={post.detailImage} alt={post.title} />
                    </div>

                    <div className="blog-post-content"
                        dangerouslySetInnerHTML={{ __html: post.content + '<div style="margin-top:2rem;"><a href=\"/about\">About Us</a> | <a href=\"/contact\">Contact Us</a></div>' }}
                    />

                    <div className="blog-post-tags">
                        {post.tags.map(tag => (
                            <span key={tag} className="blog-post-tag">{tag}</span>
                        ))}
                    </div>

                    <div className="blog-post-navigation">
                        <Link to="/blog" className="blog-post-link">
                            View All Posts
                        </Link>
                    </div>
                </div>
            </div>
        </>
    );
};

export default BlogPost; 